import Header from './components/Header';
import Hero from './components/Hero';
import Topics from './components/Topics';
import Updates from './components/Updates';
import Comments from './components/Comments';
import Features from './components/Features';
import AppSection from './components/AppSection';
import Ranking from './components/Ranking';
import AboutContact from './components/AboutContact';
import Media from './components/Media';
import IndexSection from './components/IndexSection';
import Cards from './components/Cards';
import Faq from './components/Faq';
import Carousel from './components/Carousel';
import Footer from './components/Footer';

export default function Home() {
  return (
    <>
      <Header />
      <main>
        <Hero />
        <Topics />
        <Updates />
        <Comments />
        <Features />
        <AppSection />
        <Ranking />
        <AboutContact />
        <Media />
        <IndexSection />
        <Cards />
        <Faq />
        <Carousel />
      </main>
      <Footer />
    </>
  );
}